<template>
  <div>
    <span class="block">{{ total | number }} total</span>
    <span class="block">
      {{ intentional | number }} intentional
      <span class="text-sm text-supplement">({{ intentionalPercentage | number }}%)</span>
    </span>
    <span class="block">
      {{ automated | number }} automated
      <span class="text-sm text-supplement">({{ automatedPercentage | number }}%)</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    intentional: {
      type: [Number, String],
      required: true
    },
    automated: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    total() {
      return Number(this.intentional) + Number(this.automated)
    },
    intentionalPercentage() {
      return (Number(this.intentional) / Number(this.total)) * 100
    },
    automatedPercentage() {
      return (Number(this.automated) / Number(this.total)) * 100
    }
  }
}
</script>
